
import React, { useState, useRef } from "react";  // ✅ REMOVE useEffect (no longer needed)
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Box, Typography, IconButton, Paper, Tabs, Tab } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import MedicineOrderTypeScreen from "./MedicineOrderTypeScreen";
import DiagnosticSampleBooking from "./DiagonsticSampleBooking";
import NursingPhysioBooking from "../NursingPhysiotheraphy/NursingPhysioBooking"

// import { fetchUserFromRedis } from "../AuthonticationPages/Register";

import { useUser } from "../../context/UserContext";
import ResponsiveContainer from '../../ResponsiveContainer';
import  bg from "../Logos/med_background2.png"

const ServiceSelectionScreen = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { serviceData } = location.state || {};


  const [activeTab, setActiveTab] = useState(0);
  const { user, loading }         = useUser();   // ← user + loading come from context now

  const visitedRef = useRef(new Set([0]));


  // ── Tab visibility by role ─────────────────────────────────────────────────
  const showMedicineTab   = user?.role === 'admin' || user?.role === 'medicineadmin';
  const showDiagnosticTab = user?.role === 'admin' || user?.role === 'diagnosticadmin';
  const showNursingPhyTab = true;

  const tabs = [];
  if (showMedicineTab)   tabs.push('medicine');
  if (showDiagnosticTab) tabs.push('diagnostic');
  if (showNursingPhyTab) tabs.push('nursingphy');

  const handleTabChange = (e, newValue) => {

    visitedRef.current.add(newValue);
    setActiveTab(newValue);
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  // ── Everything below is UNCHANGED from your original ──────────────────────

  return (
    <ResponsiveContainer withSidebar={true}>
      <Box sx={{ minHeight: '100vh', bgcolor: '#F9FAFB', width: '100%', maxWidth: '100%', pb: 4 }}>

        <Paper elevation={0} sx={{ background: `
      linear-gradient(
        135deg,
        rgba(0,109,119,0.9) 0%,
        rgba(0,169,181,0.68) 100%
      ),
      url(${bg})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    position: "sticky",
    top: 0,
    zIndex: 10, position: "sticky", top: 0, zIndex: 10 }}>
          <Container maxWidth="lg">
            <Box sx={{
              display: "flex", justifyContent: "space-between", alignItems: "center",
              py: { xs: 1.5, sm: 2 }, flexWrap: 'nowrap',
            }}>
              <IconButton onClick={() => navigate(-1)} sx={{ color: "#ffffff", p: { xs: 0.5, sm: 1 } }}>
                <ArrowBack sx={{ fontSize: { xs: 24, sm: 28, md: 32 } }} />
              </IconButton>
              <Typography variant="h6" sx={{
                fontSize: { xs: 20, sm: 28, md: 40 },
                fontWeight: 700, color: "#ffffff",
                textAlign: 'center', flex: 1,
              }}>
                Choose Service
              </Typography>
              <Box sx={{ width: { xs: 32, sm: 40 } }} />
            </Box>
          </Container>
        </Paper>

        <Container maxWidth="xl" sx={{ py: { xs: 2, sm: 3, md: 4 }, px: { xs: 1, sm: 2 } }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              textColor="#006D77"
              TabIndicatorProps={{ sx: { backgroundColor: '#006D77' } }}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                '& .MuiTab-root': {
                  color: '#006D77',
                  fontSize: { xs: '13px', sm: '15px', md: '18px' },
                  minWidth: { xs: 'auto', sm: 120 },
                  px: { xs: 1.5, sm: 2, md: 3 },
                  textTransform: 'none',
                },
                '& .Mui-selected': { color: '#006D77 !important', fontWeight: 'bold' },
              }}
            >
              {showMedicineTab   && <Tab label="Medicines" />}
              {showDiagnosticTab && <Tab label="Diagnostics" />}
              {showNursingPhyTab && <Tab label="Nursing & Physio" />}
            </Tabs>
          </Box>

          <Box sx={{ width: '100%', maxWidth: '100%', overflow: 'hidden' }}>

            {showMedicineTab && (() => {
              const idx = tabs.indexOf('medicine');
              if (!visitedRef.current.has(idx)) return null;
              return (
                <Box sx={{ display: activeTab === idx ? 'block' : 'none' }}>
                  <MedicineOrderTypeScreen serviceData={serviceData} />
                </Box>
              );
            })()}

            {showDiagnosticTab && (() => {
              const idx = tabs.indexOf('diagnostic');
              if (!visitedRef.current.has(idx)) return null;
              return (
                <Box sx={{ display: activeTab === idx ? 'block' : 'none' }}>
                  <DiagnosticSampleBooking serviceData={serviceData} embedded={true} />
                </Box>
              );
            })()}

            {showNursingPhyTab && (() => {
              const idx = tabs.indexOf('nursingphy');
              if (!visitedRef.current.has(idx)) return null;
              return (
                <Box sx={{ display: activeTab === idx ? 'block' : 'none' }}>
                  <NursingPhysioBooking serviceData={serviceData} embedded={true} />
                </Box>
              );
            })()}

          </Box>
        </Container>
      </Box>
    </ResponsiveContainer>
  );
};

export default ServiceSelectionScreen;